  (function () {
    var root = document.getElementById('hjg-amb');
    if (!root) return;
    var form = root.querySelector('[data-step]');
    if (!form) return;

    var panes = root.querySelectorAll('[data-step-pane]');
    var TOTAL = panes.length || 2;
    var step = 1;
    var segs = root.querySelectorAll('.hjg-stepper__seg');
    var btnNext = root.querySelector('[data-next]');
    var btnPrev = root.querySelector('[data-prev]');
    var btnSubmit = root.querySelector('[data-submit]');
    var curLabel = root.querySelector('[data-cur]');
    var errEl = root.querySelector('[data-err]');
    var ageInput = root.querySelector('[data-age]');
    var parentCheckRow = root.querySelector('[data-parent-check]');
    var parentOk = root.querySelector('[data-parent-ok]');

    function parentThreshold() {
      if (!ageInput) return 14;
      var t = parseInt(ageInput.getAttribute('data-parent-threshold'), 10);
      return isNaN(t) ? 14 : t;
    }

    function needsParent() {
      var v = parseInt(ageInput && ageInput.value, 10);
      return !isNaN(v) && v > 0 && v < parentThreshold();
    }

    function refreshParentVisibility() {
      var show = needsParent();
      if (parentCheckRow) {
        parentCheckRow.hidden = !show;
        if (parentOk) {
          if (show) parentOk.setAttribute('required', '');
          else { parentOk.removeAttribute('required'); parentOk.checked = false; }
        }
      }
    }

    function validateStep(n) {
      var pane = root.querySelector('[data-step-pane="' + n + '"]');
      if (!pane) return true;
      var required = pane.querySelectorAll('[required]');
      for (var i = 0; i < required.length; i++) {
        var el = required[i];
        if (el.offsetParent === null && el.type !== 'radio' && el.type !== 'checkbox') continue;
        if (el.type === 'checkbox') {
          if (!el.checked) return false;
        } else if (el.type === 'radio') {
          var name = el.name;
          if (!root.querySelector('input[name="' + name + '"]:checked')) return false;
        } else {
          if (!el.value || !el.value.toString().trim()) return false;
          if (el.type === 'number') {
            var num = Number(el.value);
            if (el.min && num < Number(el.min)) return false;
            if (el.max && num > Number(el.max)) return false;
          }
          if (el.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(el.value)) return false;
        }
      }
      // Cas particulier : si on est à la dernière étape et que l'âge requiert
      // l'accord parent, la case doit être cochée.
      if (n === TOTAL && needsParent() && parentOk && !parentOk.checked) return false;
      return true;
    }

    function render() {
      panes.forEach(function (p) { p.hidden = (parseInt(p.dataset.stepPane, 10) !== step); });
      segs.forEach(function (s) {
        var n = parseInt(s.dataset.seg, 10);
        s.classList.toggle('is-current', n === step);
        s.classList.toggle('is-done', n < step);
      });
      if (curLabel) curLabel.textContent = String(step);
      if (btnPrev) btnPrev.hidden = step <= 1;
      if (btnNext) btnNext.hidden = step >= TOTAL;
      if (btnSubmit) btnSubmit.hidden = step < TOTAL;
      if (errEl) errEl.hidden = true;
    }

    if (btnNext) btnNext.addEventListener('click', function () {
      if (validateStep(step)) {
        step = Math.min(TOTAL, step + 1);
        render();
        window.scrollTo({ top: form.getBoundingClientRect().top + window.scrollY - 40, behavior: 'smooth' });
      } else {
        if (errEl) errEl.hidden = false;
      }
    });
    if (btnPrev) btnPrev.addEventListener('click', function () {
      step = Math.max(1, step - 1);
      render();
    });
    form.addEventListener('submit', function (e) {
      if (!validateStep(TOTAL)) {
        e.preventDefault();
        if (errEl) errEl.hidden = false;
      }
    });
    if (ageInput) ageInput.addEventListener('input', refreshParentVisibility);

    refreshParentVisibility();
    render();
  })();
